<template>
	<template v-if="!isLoading">
		<Row class="pb-0 !pt-8 bg-white flex-col">
			<!-- <div class="container xl:container gap-[80px] mx-auto">
				<TitleWithLeftBorder
					text="News"
					class="mb-[16px] md:mb-[32px] ml-auto"
				/>
			</div> -->

			<div class="container xl:container mx-auto">
				<img
					src="/images/ts-news-image.png"
					alt=""
					class="max-w-[900px] w-full mx-auto mb-8"
				/>
			</div>
		</Row>
		<Row>
			<div class="xl:container gap-[80px]">
				<section
					v-if="list && list.length > 0 && !isLoading"
					id="blog-list"
					class="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-[32px] px-[16px] md:px-[32px] xl:px-0"
				>
					<template
						v-for="(post, index) in list"
						:key="post.id"
					>
						<PostTile
							:id="post.id"
							:content_read_time="post.content_read_time"
							:source-url="post.image ?? '/images/ts-news-image.png'"
							:title="post.title"
							:slug="post.slug + '/'"
							:data-page="post.page"
							:is-news="true"
						/>

						<AdButlerGrid
							:ad-id="719238"
							v-if="(index + 1) % 5 === 0 && showAds"
							:data-page="post.page"
						/>

						<div
							v-else-if="(index + 1) % 5 === 0 && !showAds"
							class="ts-grid-fallback"
						></div>
					</template>
				</section>

				<section
					v-else
					class="h-[900px]"
				/>
			</div>
		</Row>
		<div
			ref="loadMoreAnchor"
			class="blog-loading-container"
		>
			<div class="post-loading">
				<img
					v-if="showLoad"
					src="/images/loading.svg"
					class="loading animation"
				/>
			</div>
		</div>
	</template>
	<div
		v-else
		class="h-[600px]"
	/>
	<Head>
		<Title>Stock Market News - Timothy Sykes</Title>
		<Link
			rel="canonical"
			:href="current_hostname + 'news/'"
		/>

		<Meta
			name="description"
			content="Timothy Sykes News delivers real-time stock market news focused on key catalysts driving short-term price movements. Our content is tailored for active traders and investors seeking to capitalize on rapid fluctuations, particularly in volatile sectors like penny stocks. Readers come to us for detailed coverage on earnings reports, mergers, FDA approvals, new contracts, and unusual trading volumes that can trigger significant short-term price action. Some users utilize our news to explain sudden stock movements, while others rely on it for diligent research into potential investment opportunities. We ground all of our reports in the Timothy Sykes method of trading, which emphasizes a strategic approach to capturing short-term momentum while avoiding undue risk exposure to the underlying stock's long-term volatility. This method is especially useful when trading penny stocks or other high-risk equities, where rapid gains can be made by understanding stock patterns, manipulation, and media hype. Our audience consists of traders ranging from beginners to advanced, many of whom have adopted Timothy’s 7-Step Pennystocking Framework. This framework helps identify stocks during bubble-like cycles, enabling traders to time their entry and exit points effectively. We offer tools, expert analysis, and educational insights into market psychology, helping traders better understand how catalysts like news releases or sector momentum drive stock prices in the short term. Whether you are an active day trader looking for key indicators on a stock's next move, or an investor doing due diligence before entering a position, Timothy Sykes News is designed to help you make informed trading decisions."
		/>
		<Meta
			property="og:description"
			content="Timothy Sykes News delivers real-time stock market news focused on key catalysts driving short-term price movements. Our content is tailored for active traders and investors seeking to capitalize on rapid fluctuations, particularly in volatile sectors like penny stocks. Readers come to us for detailed coverage on earnings reports, mergers, FDA approvals, new contracts, and unusual trading volumes that can trigger significant short-term price action. Some users utilize our news to explain sudden stock movements, while others rely on it for diligent research into potential investment opportunities. We ground all of our reports in the Timothy Sykes method of trading, which emphasizes a strategic approach to capturing short-term momentum while avoiding undue risk exposure to the underlying stock's long-term volatility. This method is especially useful when trading penny stocks or other high-risk equities, where rapid gains can be made by understanding stock patterns, manipulation, and media hype. Our audience consists of traders ranging from beginners to advanced, many of whom have adopted Timothy’s 7-Step Pennystocking Framework. This framework helps identify stocks during bubble-like cycles, enabling traders to time their entry and exit points effectively. We offer tools, expert analysis, and educational insights into market psychology, helping traders better understand how catalysts like news releases or sector momentum drive stock prices in the short term. Whether you are an active day trader looking for key indicators on a stock's next move, or an investor doing due diligence before entering a position, Timothy Sykes News is designed to help you make informed trading decisions."
		/>

		<template v-if="head_seo">
			<template
				v-for="(tag, i) in head_seo"
				:key="i"
			>
				<Meta
					v-if="tag[0].startsWith('og_')"
					:property="'og:' + tag[0].slice(3)"
					:content="tag[1][0].url || tag[1]"
				/>

				<Meta
					v-else-if="tag[0].startsWith('article')"
					:property="'article:' + tag[0].slice(8)"
					:content="tag[1]"
				/>
				<Meta
					v-else-if="tag[0] !== 'twitter_misc' && tag[0].startsWith('twitter')"
					:name="'twitter:' + tag[0].slice(8)"
					:content="tag[1]"
				/>

				<template v-else-if="tag[0] === 'twitter_misc'">
					<Meta
						:name="'twitter:label1'"
						:content="Object.keys(tag[1])[0]"
					/>
					<Meta
						:name="'twitter:data2'"
						:content="Object.values(tag[1])[0]"
					/>
					<Meta
						:name="'twitter:label2'"
						:content="Object.keys(tag[1])[1]"
					/>
					<Meta
						:name="'twitter:data1'"
						:content="Object.values(tag[1])[1]"
					/>
				</template>

				<Meta
					v-else-if="tag[0] != 'og_image'"
					:name="tag[0]"
					:content="tag[1]"
				/>
				<template v-else>
					<Meta
						:property="tag[0].split('_').join(':') + ':type'"
						:content="tag[1][0].type"
					/>
					<Meta
						:property="tag[0].split('_').join(':')"
						:content="tag[1][0].url"
					/>
					<Meta
						:property="tag[0].split('_').join(':') + ':width'"
						:content="tag[1][0].width"
					/>
					<Meta
						:property="tag[0].split('_').join(':') + ':height'"
						:content="tag[1][0].height"
					/>
				</template>
			</template>
		</template>
	</Head>
</template>

<script setup>
import axios from "axios";
import { load } from "cheerio";
const $route = useRoute();
const $route_name = ref("");
const showAds = ref(false);
const showLoad = ref(false);
const news_pagination = reactive({
	page: 1,
	current_page: 1,
	total_pages: 1,
	previous_page: 0
});
const posts = ref([]);
const loadMore = ref(false);
const loadMoreAnchor = ref();
const route_name = ref("");
const isPushStatePending = ref(false);
const hostname = useRuntimeConfig().public.hostname;
const { current_hostname } = useRuntimeConfig().public;
const { $postsListDict } = useNuxtApp();

const isLoading = ref(true);
const head_seo = computed(() => {
	if (yoast_head_json) {
		const filtered = Object.entries(yoast_head_json)
			.filter(
				(item) =>
					![
						"title",
						"robots",
						"canonical",
						"schema_json",
						"description",
						"og_description",
						"WordPressAuthor_YoastHeadJson_Schema_"
					].includes(item[0])
			)
			.map((item) => {
				if (item[0] === "og_image") {
					item[1][0].url = current_hostname + "images/ts-news-image.png";
				}

				return item;
			});

		return filtered;
	}

	return null;
});

const { data } = await useAsyncData(
	"page_seo_data",
	async ({ $config, $router }) => {
		const { data } = await axios.get(`${hostname}wp-json/wp/v2/pages/9014/`);

		const { yoast_head_json, yoast_meta } = data;
		const { schema_json } = data.yoast_head_json;

		let posts = Object.entries($postsListDict)
			.filter(([_, value]) => value.type === "news" && value.status === "publish")
			.map(([_, value]) => value);

		const total_pages = Math.ceil(posts.length / 20);

		const pages_number = Number(
			$router.currentRoute._rawValue.params &&
				$router.currentRoute._rawValue.params.number &&
				$router.currentRoute._rawValue.params.number.length > 0
				? $router.currentRoute._rawValue.params.number[0]
				: 1
		);

		if (pages_number > 1) {
			posts = posts.slice(pages_number * 20, pages_number * 20 + 20);
		} else {
			posts = posts.slice(0, 20);
		}

		posts.forEach((post, _) => {
			let content;

			if (post.content) {
				content = load(post.content, {
					decodeEntities: false
				}).text();
			} else {
				content = "";
			}
			post.content = content;

			post.page = pages_number;
		});

		let parsed_schema;
		if (schema_json) {
			parsed_schema = JSON.parse(schema_json);
			const parsed_schema_id = parse_saswpSchema(
				parsed_schema["@graph"],
				$config.public.hostname,
				$config.public.current_hostname
			);

			parsed_schema["@graph"] = parsed_schema_id;
		}

		const schema_stuff = {
			"@context": "https://schema.org",
			"@graph": [
				{
					"@type": ["WebPage", "CollectionPage"],
					"@id": $config.public.current_hostname + "news/",
					url: $config.public.current_hostname + "news/",
					name: "Stock Market News - Timothy Sykes",
					isPartOf: {
						"@id": $config.public.current_hostname + "#website"
					},
					primaryImageOfPage: {
						"@id": "https://timothysykes.com/news/#primaryimage"
					},
					image: {
						"@id": $config.public.hostname + "news/#primaryimage"
					},
					thumbnailUrl: "https://timothysykes.com/images/ts-news-image.png",
					datePublished: "2024-09-12T10:10:00Z",
					dateModified: "2024-09-12T10:10:00Z",
					description:
						"Timothy Sykes News delivers real-time stock market news focused on key catalysts driving short-term price movements. Our content is tailored for active traders and investors seeking to capitalize on rapid fluctuations, particularly in volatile sectors like penny stocks. Readers come to us for detailed coverage on earnings reports, mergers, FDA approvals, new contracts, and unusual trading volumes that can trigger significant short-term price action. Some users utilize our news to explain sudden stock movements, while others rely on it for diligent research into potential investment opportunities. We ground all of our reports in the Timothy Sykes method of trading, which emphasizes a strategic approach to capturing short-term momentum while avoiding undue risk exposure to the underlying stock's long-term volatility. This method is especially useful when trading penny stocks or other high-risk equities, where rapid gains can be made by understanding stock patterns, manipulation, and media hype. Our audience consists of traders ranging from beginners to advanced, many of whom have adopted Timothy’s 7-Step Pennystocking Framework. This framework helps identify stocks during bubble-like cycles, enabling traders to time their entry and exit points effectively. We offer tools, expert analysis, and educational insights into market psychology, helping traders better understand how catalysts like news releases or sector momentum drive stock prices in the short term. Whether you are an active day trader looking for key indicators on a stock's next move, or an investor doing due diligence before entering a position, Timothy Sykes News is designed to help you make informed trading decisions.",
					breadcrumb: {
						"@id": $config.public.current_hostname + "news/#breadcrumb"
					},
					inLanguage: "en-US"
				},
				{
					"@type": "ImageObject",
					inLanguage: "en-US",
					"@id": $config.public.current_hostname + "news/#primaryimage",
					url: $config.public.hostname + "images/ts-news-image.png",
					contentUrl: "https://timothysykes.com/images/ts-news-image.png",
					width: 1000,
					height: 721,
					caption: "current ratio limitations"
				},
				{
					"@type": "BreadcrumbList",
					"@id": $config.public.current_hostname + "news/#breadcrumb",
					itemListElement: [
						{
							"@type": "ListItem",
							position: 1,
							name: "Home",
							item: $config.public.current_hostname + ""
						},
						{ "@type": "ListItem", position: 2, name: "News &#8211; Timothy Sykes" }
					]
				},
				{
					"@type": "WebSite",
					"@id": $config.public.current_hostname + "#website",
					url: $config.public.current_hostname + "",
					name: "Timothy Sykes",
					description: "How To Trade Penny Stocks Without The Stock Promoter BS",
					publisher: {
						"@id":
							$config.public.current_hostname +
							"#/schema/person/9acd0cdbfa16f9846109176e93fd4ac4"
					},

					inLanguage: "en-US"
				},
				{
					"@type": ["Person", "Organization"],
					"@id":
						$config.public.current_hostname +
						"#/schema/person/9acd0cdbfa16f9846109176e93fd4ac4",
					name: "Timothy Sykes",
					image: {
						"@type": "ImageObject",
						inLanguage: "en-US",
						"@id": $config.public.hostname + "#/schema/person/image/",
						url: "https://content.timothysykes.com/wp-content/uploads/2016/09/timothy-sykes-665x385.jpg",
						contentUrl:
							"https://content.timothysykes.com/wp-content/uploads/2016/09/timothy-sykes-665x385.jpg",
						width: 665,
						height: 385,
						caption: "Timothy Sykes"
					},
					logo: {
						"@id": $config.public.hostname + "#/schema/person/image/"
					},
					sameAs: [
						$config.public.current_hostname + "blog/author/timothysykes/",
						"https://x.com/timothysykes",
						"https://news.google.com/publications/CAAqBwgKMJbmngswsvC2Aw?hl=en-US&gl=US&ceid=US%3Aen"
					]
				}
			]
		};

		return {
			yoast_head_json,
			yoast_meta,
			schema_json: schema_stuff,
			list: posts,
			pagination_stuff: {
				pageNumber: pages_number,
				previousPageNumber: pages_number > 1 ? pages_number - 1 : null,
				total_pages
			}
		};
	}
);

if (!data.value) {
	throw createError({
		statusCode: 404,
		statusMessage: "Page Not Found",
		fatal: true
	});
}

const { yoast_head_json, schema_json, list, pagination_stuff } = data.value;

const pageObserver = () => {
	const observer = new IntersectionObserver(
		function (entry) {
			if (entry[0].isIntersecting === true) {
				const page_num = Number(entry[0].target.getAttribute("data-page"));

				if (page_num && page_num > 0) {
					let url;

					const regex = /^\/news\/page\/\d+\/$/;

					if (route_name === "/news/" || regex.test(route_name)) {
						url = page_num === 1 ? "/news/" : "/news/page/" + page_num + "/";
					} else {
						let page_url = window.location.pathname;
						page_url = page_url.split("page")[0];

						url = page_num === 1 ? page_url : page_url + "page/" + page_num + "/";
					}

					if (!isPushStatePending.value) {
						history.pushState({}, null, url);
					}
					isPushStatePending.value = true;
					setTimeout(() => {
						isPushStatePending.value = false;
					}, 500);
				}
			}
		},
		{ threshold: [0] }
	);

	document.querySelectorAll(".post-tile").forEach((entry) => {
		observer.observe(entry);
	});
};

const isElementInViewport = (element) => {
	if (!element) {
		return false;
	}

	const rect = element.getBoundingClientRect();
	return rect.bottom > 0 && rect.top < window.innerHeight;
};

const loadMorePost = () => {
	loadMore.value = false;
	const next_page = news_pagination.current_page + 1;

	let posts_arr = Object.entries($postsListDict)
		.filter(([_, value]) => value.type === "news")
		.map(([_, value]) => value);

	const number = Number(next_page);

	posts_arr = posts_arr.slice(number * 20, number * 20 + 20);

	const posts_formatted = posts_arr.map((post) => {
		return {
			...post,
			page: next_page
		};
	});

	posts_formatted.forEach((post) => {
		list.push({
			...post,
			image: post.image
		});
	});

	news_pagination.current_page = next_page;

	setTimeout(() => (loadMore.value = true), 250);

	if (!window.adsAreWithUs) {
		fetchFallbackAdbutlerBanner("ts-grid-ad", ".ts-grid-fallback");
	}
};

const loadMorePostBackwards = () => {
	const previous_page = news_pagination?.previous_page;

	loadMore.value = false;

	let posts_arr = Object.entries($postsListDict)
		.filter(([_, value]) => value.type === "news")
		.map(([_, value]) => value);

	const number = Number(previous_page);
	posts_arr = posts_arr.slice(0, number * 20);

	const posts_formatted = posts_arr.map((post) => {
		return {
			...post,
			page: previous_page
		};
	});

	posts_formatted.forEach((post) => {
		list.unshift({
			...post,
			image: post.image
		});
	});

	setTimeout(() => {
		const total_gap_per_row = 32 * 5;
		const total_tile_height_per_row = 292 * 5;
		const total_blog_header_space = 44 + 172;

		window.scrollTo(
			0,
			total_tile_height_per_row + total_gap_per_row + total_blog_header_space
		);
		news_pagination.previous_page = previous_page - 1;

		loadMore.value = true;
	}, 250);

	if (!window.adsAreWithUs) {
		fetchFallbackAdbutlerBanner("ts-grid-ad", ".ts-grid-fallback");
	}
};

const isAtTop = () => {
	return window.scrollY === 0;
};

const handleVisibilityChange = () => {
	const visibilityCheck = isElementInViewport(loadMoreAnchor.value);

	if (
		isAtTop() &&
		loadMore.value === true &&
		news_pagination.previous_page > 0 &&
		news_pagination.current_page !== 1
	) {
		loadMorePostBackwards();
	}

	if (
		news_pagination.current_page <= news_pagination.total_pages &&
		visibilityCheck &&
		loadMore.value === true
		// &&this.currentPage != this.totalPages
	) {
		showLoad.value = true;
		loadMore.value = false;
		loadMorePost();
	}
};

const scrollSuperThing = () => {
	if (/^\/news\/[^/]+\/?$/.test(window.location.pathname)) {
		window.removeEventListener("scroll", scrollSuperThing);

		return;
	}

	handleVisibilityChange();
	pageObserver();
};

watch($route, (newPath, oldPath) => {
	if (process.client) {
		if (newPath !== oldPath) {
			window.removeEventListener("scroll", scrollSuperThing);
		}

		showAds.value = window.adsAreWithUs;
	}
});

onMounted(async () => {
	$route_name.value = $route.name;

	news_pagination.page = pagination_stuff.pageNumber;
	news_pagination.total_pages = pagination_stuff.total_pages;
	news_pagination.previous_page = pagination_stuff.pageNumber - 1;
	news_pagination.current_page = pagination_stuff.pageNumber;

	if (list) {
		posts.value = list;
	}

	if (process.client) {
		route_name.value = window.location.pathname;

		if (window.adsAreWithUs) {
			showAds.value = window.adsAreWithUs;
		} else {
			fetchFallbackAdbutlerBanner("ts-grid-ad", ".ts-grid-fallback");
		}
	}

	if (list && process.client) {
		isLoading.value = false;

		await setTimeout(() => window.scrollTo(0, 1), 1000);

		window.addEventListener("scroll", scrollSuperThing, { passive: true });

		if (news_pagination.current_page < news_pagination.total_pages) {
			loadMore.value = true;
		}

		showAds.value = window.adsAreWithUs;
	}
});

useHead({
	script: [
		{
			type: "application/ld+json",
			class: "saswp-schema-markup-output",
			innerHTML: JSON.stringify(schema_json)
		}
	]
});
</script>
